import { render, staticRenderFns } from "./crossCheckAiOcr.vue?vue&type=template&id=4e642d3a&scoped=true&"
import script from "./crossCheckAiOcr.vue?vue&type=script&lang=js&"
export * from "./crossCheckAiOcr.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckAiOcr.vue?vue&type=style&index=0&id=4e642d3a&lang=scss&scoped=true&"
import style1 from "./crossCheckAiOcr.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e642d3a",
  null
  
)

export default component.exports